import { useCallback } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { store } from '@febos-io/auth';
import { hooks as commonHooks } from '@febos-io/common';
import { searchPatientInCompany } from '../config';
import { setPatients } from '../store';
import { Patient } from '../types';

/**
 * Interfaz para los datos básicos de un paciente
 */


/**
 * Interfaz para la respuesta de búsqueda de Elasticsearch
 */
interface SearchResponse {
  hits: {
    hits: Array<{
      source: Patient;
    }>;
  };
}

/**
 * Interfaz para el query de búsqueda de Elasticsearch
 */
interface SearchQuery {
  query: {
    bool: {
      must: Array<{
        query_string: {
          query: string;
        };
      }>;
    };
  };
}

/**
 * Interfaz para el retorno del hook
 */
interface UsePatientSearchReturn {
  loading: boolean;
  searchPatients: (value: string) => Promise<void>;
}

/**
 * Hook personalizado para manejar la búsqueda de pacientes
 * @returns {UsePatientSearchReturn} - Objeto con loading state y función de búsqueda
 */
export const usePatientSearch = (): UsePatientSearchReturn => {
  const dispatch = useDispatch();
  const companyId:string = useSelector(store.getCompanyId);

  const { loading, callback: searchPatients } = commonHooks.useRequestCallback(
    useCallback(
      async (request: any, value: string): Promise<void> => {
        try {
          const searchQuery: SearchQuery = {
            query: {
              bool: {
                must: [
                  {
                    query_string: {
                      query: `*${value}*`,
                    },
                  },
                ],
              },
            },
          };

          const { data }: { data: SearchResponse } = await request.exec(
            searchPatientInCompany(companyId, 1, 20, searchQuery),
          );

          const patientList: Patient[] = data.hits.hits.map((item) => item.source);

          // Despachar los pacientes al store
          dispatch(
            setPatients({
              companyId,
              patients: patientList.reduce(
                (index: Record<string, Patient>, item: Patient) => ({
                  ...index,
                  [item.id]: {
                    ...item
                  },
                }),
                {},
              ),
            }),
          );
        } catch (error) {
          // eslint-disable-next-line no-console
          console.error('Error searching patients:', error);
        }
      },
      [companyId, dispatch],
    ),
  );

  return {
    loading,
    searchPatients,
  };
};

export default usePatientSearch;
